import { render, staticRenderFns } from "./WithdrawVoucherCandle.vue?vue&type=template&id=004fdabc&"
import script from "./WithdrawVoucherCandle.vue?vue&type=script&lang=js&"
export * from "./WithdrawVoucherCandle.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawVoucherCandle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports